import React from 'react';
import { Box } from '@material-ui/core';
import styled from 'styled-components';
import { SubTitle, Paragraph } from './legal-formatting';

const Layout = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 475px;
  gap: 6px;
`;

export default () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100vh',
      backgroundColor: '#fff',
      color: '#505661',
    }}
  >
    <Layout>
      <SubTitle>
        We&apos;re sorry, but the application failed to start due to a configuration
        error
      </SubTitle>
      <Paragraph>
        Please contact your system administrator to resolve this issue
      </Paragraph>
    </Layout>
  </div>
);
